var React = require('react');

function AR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.68 23.28l-1.68-18.8 30 0.4h31.040l1.2 2v1.44l-3.12 2.96-1.12 2.16 9.12-0.4 0.56 1.76-0.96-0.24-0.56 0.64 1.28 0.8-3.36 1.68 0.56 1.36-0.4 0.88 0.24 0.88-1.28 0.64-0.080 1.040-1.12 1.52 0.56 3.44-0.48 0.48h-0.8l-0.72 1.44-1.28 0.8 0.48 1.52-2.48 1.52-0.16 1.52h-1.12l-0.64 1.6v3.76l-1.2 0.72-0.88-0.080v1.6h-0.96l-0.48 1.44-1.52 0.72 1.2 1.040-0.16 1.040-2.88 0.96 0.96 0.88-0.64 0.96 0.48 1.040-2.48 2.24 1.040 0.88-0.16 0.8-1.040 0.32 1.52 1.6v1.68l-0.72 0.8 0.96 0.88 0.24 2-0.96 0.56v1.84h-41.2v-9.36l-1.92-0.72-2.88 0.4 0.080-0.4h-0.72l-0.8-1.2z"}));
}

AR.defaultProps = {"version":"1.1","width":"76","height":"80","viewBox":"0 0 76 80"};

module.exports = AR;

AR.default = AR;
